/** Temporary seller maintenance gate — remove this file and its usage when no longer needed. */
export const SELLER_MAINTENANCE_KEY = "seller_maintenance_mode";

/** Default ON. Set localStorage seller_maintenance_mode = "false" to bypass for testing. */
export const isSellerMaintenanceEnabled = () =>
  localStorage.getItem(SELLER_MAINTENANCE_KEY) !== "false";
